import { useMemo } from "react";

import { useGetSectionByIdQuery } from "@/redux/service.js";
import Question from "./Question.jsx";
import BaseTabs from "@/components_v2/Tabs/BaseTabs";
import { SectionContentProps } from "@/features/survey/form/types";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import SectionFooter from "@/features/survey/form/components/SectionFooter";
import SectionHeader from "@/features/survey/form/components/SectionHeader";

const SectionContent = ({ sectionId }: SectionContentProps) => {
  const { data: section, isLoading } = useGetSectionByIdQuery(sectionId);

  const sectionTabs = useMemo(() => {
    if (!section) return [];

    return section.tabs.map((tab) => ({
      key: tab.title.toLowerCase(),
      label: tab.title,
      children: (
        <div className="section-content-container">
          {tab.questions.map((i) => (
            <Question key={i} questionId={i} />
          ))}
        </div>
      ),
    }));
  }, [section]);

  if (isLoading) {
    return <BaseSpinner />;
  }

  return (
    section && (
      <div className="section-content">
        <SectionHeader section={section} />
        <h6 className="body-m-regular">{section.helpText}</h6>
        {sectionTabs.length > 0 ? (
          <BaseTabs items={sectionTabs} variant="fullWidth" type="card" />
        ) : (
          <>
            {section.questions.map((i) => (
              <Question key={i} questionId={i} />
            ))}
          </>
        )}
        <SectionFooter section={section} />
      </div>
    )
  );
};

export default SectionContent;
